import { render, staticRenderFns } from "./CompanyShow.vue?vue&type=template&id=0eac5e55"
import script from "./CompanyShow.vue?vue&type=script&lang=ts"
export * from "./CompanyShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports